/*
 * @Author: Roman
 * @Date: 2022-06-25 14:40:17
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2022-11-08 17:22:21
 * @FilePath: \qpmn-site\src\app\pages\products\catalog\CatalogSortFactory.ts
 * @Description: 
 */

import { LowestPriceSort } from "@modules/product/catalog-product/model/dto/LowestPriceSort";
import { MaximumPriceSort } from "@modules/product/catalog-product/model/dto/MaximumPriceSort";
import { NewProductsSort } from "@modules/product/catalog-product/model/dto/NewProductsSort";
import { PrioritySort } from "@modules/product/catalog-product/model/dto/PrioritySort";
import { SortType } from "@modules/product/catalog-product/model/dto/SortType.enum";


/**
 * @description 创建产品分类Sort简单工厂
 */
export class CatalogSortFactory {

    // qpmn.product.model.dto.ICatalogSortType
    public creatSort(sortType: string): qpmn.product.model.dto.IPageSort {
        if (sortType == SortType.LOWESTPRICE) {
            return new LowestPriceSort();
        } else if (sortType == SortType.MAXIMUMPRICE) {
            return new MaximumPriceSort();
        } else if (sortType == SortType.NEWPRODUCTS) {
            return new NewProductsSort();
        }else if(sortType == SortType.PRIORITYSORT){
            return new  PrioritySort();
        }
        else {
            throw new Error("Creat Catalog Sort Fail");
        }
    }
}